import React, { FC, useState } from "react";

import { FileTable, FolderExplorer } from "./components";

import { Stack } from "@components/base";

const DocumentDashboard: FC = () => {
  const [activeFolderId, setActiveFolderId] = useState<string>("");

  return (
    <Stack gap={4} mt={2}>
      <FolderExplorer
        folderId={activeFolderId ?? ""}
        setFolderId={setActiveFolderId}
      />
      <FileTable folderId={activeFolderId ?? ""} setFolderId={setActiveFolderId} />
    </Stack>
  );
};

export default DocumentDashboard;
